import { selectWarehouse } from 'containers/Warehouses/warehousesSlice'
import Warehouse from 'containers/Warehouses/WarehouseComponent'
import useWarehousesLoading from 'hooks/useWarehousesLoading'
import { useHistory, useParams } from 'react-router-dom'
import MagActions from 'containers/Warehouse/MagActions'
import MagHistory from 'containers/Warehouse/MagHistory'
import MagAccess from 'containers/Warehouse/MagAccess'
import MagManage from 'containers/Warehouse/MagManage'
import MagStatus from 'containers/Warehouse/MagStatus'
import { SECTION_TYPES } from 'containers/Warehouse'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import MagNumber from 'components/MagNumber'
import { useReduxSelector } from 'store'
import './style.scss'

const DesktopWarehouse = () => {
  const { id } = useParams()
  const { name, contractId, placeAddress, typeName, isShared, acronym, doorState, inFuture, dateFrom, sharing, events, permissions } = useReduxSelector(state => selectWarehouse(state, id))

  useWarehousesLoading(!contractId)

  const { push, goBack } = useHistory()
  const { t } = useTranslation('warehouse')
  const goTo = (path) => {
    push(`/warehouses/${id}/${path}`)
  }


  return (
    <div className='desktopWarehouse'>
      <div className='title --withBtn'>
        <div>{typeName}</div>
        <div className='group'>
          <span>{placeAddress}</span>
        </div>
        <ArrowBtn
          text={t('back')}
          className='--reverse --black'
          action={goBack}
        />
      </div>
      <div className="desktopWarehouse__wrap">
        <div className="desktopWarehouse__sidebar">
          <MagNumber
            number={name}
            isShared={isShared}
            acronym={acronym}
            isDesktop={true}
          />
          <Warehouse
            inFuture={inFuture}
            dateFrom={dateFrom}
            doorState={doorState}
          />
          <MagStatus isDesktop />
          <MagActions
            id={id}
            expanded={true}
            toggleMenu={false} />
        </div>
        <div className="desktopWarehouse__content">
          <MagManage
            id={id}
            goTo={goTo}
            isDesktop
          />
          {(Array.isArray(events) && events.length > 0 && (!isShared || permissions?.includes('events'))) && <MagHistory
            id={id}
            more={() => {
              goTo(SECTION_TYPES.history)
            }}
          />}
          {Array.isArray(sharing) && sharing.length > 0 && (!isShared || permissions?.includes('share')) && <MagAccess
            more={() => {
              goTo(SECTION_TYPES.access)
            }}
          />}
        </div>
      </div>
    </div>
  )
}

export default DesktopWarehouse